import { render, staticRenderFns } from "./NullTextField.vue?vue&type=template&id=210a8d04&"
import script from "./NullTextField.vue?vue&type=script&lang=js&"
export * from "./NullTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports